export default __webpack_public_path__ + "static/media/nike-logo.2fad7ec7.svg";